import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'

import { cn } from '@/lib/utils'

// Renders Markdown written with <RichTextEditor>. Raw HTML is not rendered and
// unsafe link protocols are dropped (react-markdown defaults). remark-breaks keeps
// single line breaks, so older plain-text content looks unchanged.
export function MarkdownContent({ children, className }: { children: string; className?: string }) {
  return (
    <div className={cn('prose prose-sm max-w-none', className)}>
      <ReactMarkdown
        remarkPlugins={[remarkBreaks]}
        components={{
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  )
}
